import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';
import { i18n } from '@shared/util/i18n';
import { notNil } from '@shared/util/notNil';
import { MBChatInput } from './MBChatInput';

interface Props {
  cardId: string;
  channelSlug: string;
  onSend?(): void;
  onFocus?(): void;
  onBlur?(): void;
}

export function MBCardChatInput({ cardId, channelSlug, ...otherProps }: Props) {
  const { data } = useQuery<API.ChannelDetailsQuery, API.ChannelDetailsQueryVariables>(
    Queries.channel.details,
    { variables: { slug: channelSlug } },
  );
  const { data: cardData } = useQuery<API.CardChatInputQuery, API.CardChatInputQueryVariables>(
    Queries.card.chatInput,
    { variables: { id: cardId } },
  );

  const users = useMemo(() => data?.channel?.users.filter(notNil) ?? [], [data?.channel?.users]);
  const groups = useMemo(() => data?.channel?.groups.filter(notNil) ?? [], [data?.channel?.groups]);

  return (
    <MBChatInput
      {...otherProps}
      autoFocus={false}
      placeholder={i18n('chat.input.placeholder', { channelName: cardData?.card?.fields?.name })}
      draftId={`thread:${cardData?.card?.threadId}`}
      users={users}
      groups={groups}
    />
  );
}
